import { computed } from "vue";
import { w as warn } from "../utils/console-42c8e8cc.mjs";
import { u as useGlobalConfig } from "../services/global-config/global-config-d78402d0.mjs";
const applyI18nTemplate = (key, values) => {
  if (!values) {
    return key;
  }
  Object.keys(values).forEach((valueKey) => {
    key = key.replace(`{${valueKey}}`, String(values[valueKey]));
  });
  return key;
};
const useTranslation = () => {
  const { globalConfig } = useGlobalConfig();
  const config = computed(() => globalConfig.value.i18n);
  return {
    /** Translate prop. Translate only if key has `$t:` prefix */
    tp: (key, values) => {
      if (!key) {
        return "";
      }
      if (key.startsWith("$t:")) {
        key = config.value[key.slice(3)] || key;
      }
      return applyI18nTemplate(key, values) || key;
    },
    t(key, values) {
      const translated = config.value[key];
      if (!translated) {
        warn(`${key} not found in VuesticUI i18n config`);
        return key;
      }
      return applyI18nTemplate(translated, values) || key;
    }
  };
};
export {
  useTranslation as u
};
//# sourceMappingURL=useTranslation-67b81a6e.mjs.map
